const headerElement = document.querySelector(".js-header");
const headerMetaNavUser = document.querySelector("#js-header-meta-nav-user");
const headerMetaNavUserPosTop = document.querySelector("#js-header-meta-nav-user-top");
const headerMetaNavUserPosSticky = document.querySelector("#js-header-meta-nav-user-sticky");
const headerNavElement = document.querySelector(".js-header-nav");
let lastSticky = false;

const setSticky = () => {
	const staticHeaderPages = ["is-landingpage", "is-checkout", "page-ContactPage", "template-pages-SignInPageTemplate"];
	// landing- and checkout-pages use a distinct header and set identifying classes on the root element
	// the shop sign-in page uses the normal header, so the CMS template class on the body is used to
	// distiguish the login page from other shop pages
	// isSticky logic should coincide with /global/src/css/shared/components/header/_header.scss
	const isStaticOnDesktop = !!staticHeaderPages.filter((className) => document.querySelector(`.${className}`)).length;
	const isMobile = !matchMedia("(min-width: 64em)").matches;

	const headerStickyOffset = parseFloat(getComputedStyle(headerElement).top);
	const headerToTopOffset = getHeaderToTopOffset();

	const isSticky = (isMobile || !isStaticOnDesktop) && headerToTopOffset <= headerStickyOffset;

	// do Changes only if sticky has changed
	const stickyChanged = lastSticky !== isSticky;
	lastSticky = isSticky;
	if (!stickyChanged) return;

	_changeStickyClasses(isSticky);
	_changeKontoNavPosition(isSticky);
};

const _changeStickyClasses = (isSticky) => {
	if (isSticky) {
		document.documentElement.classList.add("is-header-sticky");
		headerElement.classList.add("is-fixed");
	} else {
		document.documentElement.classList.remove("is-header-sticky");
		headerElement.classList.remove("is-fixed");
	}
};

const _changeKontoNavPosition = (sticky) => {
	const kontoPosition = sticky ? headerMetaNavUserPosSticky : headerMetaNavUserPosTop;
	if (!kontoPosition) return;
	kontoPosition.appendChild(headerMetaNavUser);
};

const setHelperClasses = () => {
	if (!headerElement) return;
	setSticky();
	["scroll", "resize"].forEach((event) => addEventListener(event, setSticky));
};

const getHeaderToTopOffset = () => {
	// Check if there is an additional header element (e.g. banner) to determine the sticky offset
	// Reason: Due to a safari bug getBoundingClientRect() returns wrong values for elements that are sticky (e.g. .header)
	const previousSibling = headerElement.previousElementSibling;
	let headerToTopOffset;
	if (previousSibling && headerNavElement) {
		// use the bottom of the previous sibling element as the offset for the header
		headerToTopOffset = previousSibling.getBoundingClientRect().bottom;
	} else {
		// use the scroll position as the offset for the header
		headerToTopOffset = -(document.documentElement.scrollTop || document.body.scrollTop);
	}
	return headerToTopOffset;
};

export default { setHelperClasses, getHeaderToTopOffset };
